module.exports = __webpack_public_path__ + "img/galeria-invertebrados2.c88633a0.jpg";